"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _variables = _interopRequireWildcard(require("../constants/variables"));
var _reduxUtils = require("@rosetta/redux-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ModalWrapperDiv = _styled["default"].div(function (props) {
  var styles = _defineProperty({
    backgroundColor: (0, _reduxUtils.extractPath)(props, "theme.promptDialogueBackground") || _variables.modalStyles.promptDialogueBackground,
    borderWidth: 1,
    borderColor: (0, _reduxUtils.extractPath)(props, "theme.promptDialogueOuterBorder") || _variables["default"].lightGrey,
    borderRadius: 10,
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    boxSizing: "content-box",
    // for apps that set box-sizing:border-box at the root of the app this will keep the modal from collapsing in strange ways
    justifyContent: "space-between",
    position: "fixed",
    transform: "translate(-50%, -60%)",
    // 60% because perfectly centered looks bad,
    zIndex: _variables.modalStyles.modalDialogZIndex,
    // @FIXME - this should probably be a prop, so each app can choose a z-index relative to other parts of the app - should have a default
    left: "50%",
    top: "50%",
    width: props.modalWidth
  }, _variables.mediaQueries.chromebook, {
    top: "60%"
  });
  if (props.minPadding) {
    styles.padding = 15;
  } else {
    styles.padding = 45;
  }
  if (props.modalHeight) {
    styles.height = props.modalHeight;
  }
  return styles;
});
var ModalWrapper = function ModalWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement(ModalWrapperDiv, {
    modalHeight: props.modalHeight,
    modalWidth: props.modalWidth,
    minPadding: props.minPadding
  }, props.children);
};
ModalWrapper.defaultProps = {
  modalWidth: 440
};
ModalWrapper.propTypes = {
  minPadding: _propTypes["default"].bool,
  modalHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  modalWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = ModalWrapper;
exports["default"] = _default;